// @ts-check

import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setActiveAuthModal } from "../redux/app/actions";

/**
 * @typedef {"login" | "register" | "mobileNumber" | "verifyNumber" | "forgotPassword" | "resetPassword"} AuthModalType
 */

const useAuthModalHook = () => {
  const dispatch = useDispatch();

  /**
   * @type {[AuthModalType | null, React.Dispatch<React.SetStateAction<AuthModalType | null>>]}
   */

  return {
    // @ts-ignore
    activeAuthModal: useSelector((state) => state.app?.activeAuthModal),
    /**
     *
     * @param {AuthModalType | null} activeModal
     */
    updateActiveAuthModal: (activeModal) => {
      // @ts-ignore
      dispatch(setActiveAuthModal(activeModal));
    },
  };
};
export default useAuthModalHook;
